/**
 * state mặc định của module
 */
export default {
	updateVersionFeatures(state, res) {
		state.VersionFeatures = [...res];
	},

	appendVersionFeatures(state, res) {
		state.VersionFeatures.append(res);
	},

	updateTotalVersionFeatures(state, res = 0) {
		state.Total = res;
	}
};
